import React, { Component } from 'react';

export default class ArchetypesIcon extends Component {
  render() {
    return <span className={'icon-archetypes'} />;
  }
}
